import React, {useEffect} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {useAuthStateManager} from '../../hooks/useAuthStateManager.tsx';
import notify from '../../lib/notify.ts';

/*
 * When the stored sign-in can't carry on (its refresh token has expired or
 * been revoked), takes the person to the
 * login page, coming back to where they were afterwards. Mounted once, inside
 * the router.
 */
const SignInEndedNotice: React.FC = () => {
    const {signInEnded, acknowledgeSignInEnded} = useAuthStateManager();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!signInEnded) {
            return;
        }

        acknowledgeSignInEnded();

        const here = location.pathname + location.search;
        if (
            location.pathname.startsWith('/login') ||
            location.pathname.startsWith('/auth/callback')
        ) {
            return;
        }

        notify.info('Please log in again.');
        navigate(`/login?${new URLSearchParams({redir: here})}`, {
            replace: true
        });
    }, [
        signInEnded,
        acknowledgeSignInEnded,
        location.pathname,
        location.search,
        navigate
    ]);

    return null;
};

export default SignInEndedNotice;
